export const PRODUCTS = {
  ACCIDENTAL_DEATH: "accidentalDeath",
  FINAL_EXPENSE: "fex",
  LTC: "ltc",
  NON_MED: "non_med",
  ACCUMULATION_IUL: "aiul",
  PROTECTION_IUL: "piul",
  PROTECTION_VUL: "pvul",
  UNIVERSAL_LIFE: "ul",
  ROP_TERM: "ropTerm",
  TERM: "term",
  WHOLE_LIFE: "wholeLife",
  LINKED_BENEFIT: "linkedBenefit",
  INCOME_RIDER: "incomeRider",
};

export const UL_TYPE = {
  [PRODUCTS.ACCUMULATION_IUL]: PRODUCTS.ACCUMULATION_IUL,
  [PRODUCTS.PROTECTION_IUL]: PRODUCTS.PROTECTION_IUL,
  [PRODUCTS.PROTECTION_VUL]: PRODUCTS.PROTECTION_VUL,
  [PRODUCTS.UNIVERSAL_LIFE]: PRODUCTS.UNIVERSAL_LIFE,
};

export const UL_TYPES = Object.values(UL_TYPE);
